'use strict';

var setGlobals = /*@ngInject*/ function(ScannerService) {
  window.scanner = ScannerService;
};

module.exports = setGlobals;
